import { render, staticRenderFns } from "./States.vue?vue&type=template&id=180fd2e2"
import script from "./States.vue?vue&type=script&lang=js"
export * from "./States.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports